import { type FC } from 'react'

import {
  type UserDocumentPosition,
  type UserDocumentPositionERx,
} from '@redteclab/api/clients/bully'
import { IconCaretRight } from '@redteclab/icons'

import {
  OrderImageItem,
  userSubOrderAccessorIsProductErx,
} from '../../../../../order'

const MAX_ITEMS = 3

export const DirectContactFormOrderSelectionCardImageThumbnail: FC<{
  products: (UserDocumentPosition | UserDocumentPositionERx)[]
}> = ({ products }) => {
  const productsWithNames = products.filter((product) => product.itemName)
  const visibleProducts = productsWithNames.slice(0, MAX_ITEMS)
  const hiddenProductsCount = productsWithNames.length - MAX_ITEMS

  return (
    <div className="mt-4 flex justify-between">
      <ul className="flex gap-2">
        {visibleProducts.map((product) => {
          const isERx = userSubOrderAccessorIsProductErx(product)
          const key = isERx
            ? (product.hashedToken ?? product.pzn ?? product.lineNum)
            : (product.offerId ?? product.pzn ?? product.lineNum)

          return (
            <li key={`${isERx ? 'erx' : 'product'}-${key}`}>
              <OrderImageItem
                alt={product.itemName ?? ''}
                data-qa-id={`direct-contact-form-${product.pzn}`}
                isERx={isERx}
                src={isERx ? undefined : product.thumbnailURL}
              />
            </li>
          )
        })}
        {hiddenProductsCount > 0 ? (
          <li className="ml-2 flex items-center text-m">
            {`+${hiddenProductsCount}`}
          </li>
        ) : null}
      </ul>
      <span aria-hidden className="flex items-center">
        <IconCaretRight className="size-8 fill-dark-brand" />
      </span>
    </div>
  )
}
